<script setup lang="ts">
import { onMounted, shallowRef } from 'vue'
import { pge as Pge, pgeCtrl, pgeInit } from './guardCtrl.js'

const props = defineProps<{
  affineX: string
  affineY: string
  pgeRZRandNum: string
  pgeRZDataB: string
  randomKey: string
  inputId: string
  inputContainerId: string
  placeholder?: string
  maxLength?: number
  async?: boolean // 是否异步初始化
}>()

const emits = defineEmits<{
  enter: [string]
  focus: []
  blur: []
  init: []
  installed: [string | boolean]
}>()

const pgeditor = shallowRef()

onMounted(() => {
  init()
})

function init() {
  pgeditor.value = new Pge({
    asynctemp: props?.async ?? false,
    pgePath: 'https://ebinfo.shengpay.com/dev/files/', // 控件下载目录，可以指定绝对路径，如"http://www.baidu.com/download/"
    pgeId: props?.inputId, // 控件id
    pgeEditType: 0, // 控件显示类型,0(星号),1(明文)
    pgeEreg1: '[\\s\\S]*', // 输入过程中字符类型限制，如"[0-9]*"表示只能输入数字
    pgeEreg2: '[\\s\\S]{6,12}', // 输入完毕后字符类型判断条件，与pgeditor.pwdValid()方法对应
    pgeMaxLength: props?.maxLength || 20, // 允许最大输入长度
    pgeTabIndex: 2, // tab键顺序
    pgeClass: 'ocx_style_next', // 控件css样式
    pgeInstallClass: 'ocx_style_next', // 针对安装或升级的css样式
    pgeOnKeyDown: handlePgeOnKeyDown, // 回车键响应函数，需焦点在控件中才能响应
    tabCallBack: 'input2', // 火狐tab键回调函数,设置要跳转到的对象ID
    AffineX: props?.affineX,
    AffineY: props?.affineY,
    pgeOnFocus: handleFocus, // 监控光标切入密码控件框
    pgeOnBlur: handleBlur, // 监控光标切出密码控件框
    pgePlaceholder: props?.placeholder || '请输入密码',
    placeholderFont: 'Microsoft YaHei', // placeholder字体类型,设置字体英文名字有效
    placeholderSize: 19, // placeholder字体大小
    placeholderFontColor: 11711154, // placeholder字体颜色设置，//11711154是灰色//46335是橘黄色
    placeholderBackColor: 16119027,
    pgeWindowID: `${props?.inputId}_${new Date().getTime()}${1}`,
    pgeRZRandNum: props.pgeRZRandNum,
    pgeRZDataB: props.pgeRZDataB,
  })

  // 绘制控件标签， 设置默认内容
  const dom = document.getElementById(props?.inputContainerId)
  pgeCtrl.pwdObjhtml(dom, pgeditor.value.load())
  // 初始化控件
  pgeInit((isI: any) => {
    console.warn('PassControl is installed? :', isI)
    emits('installed', isI)
  }, () => {
    console.warn('PassControl is init')
    emits('init')
  }, props?.async || false)
}

function handleFocus() {
  emits('focus')
}
function handleBlur() {
  emits('blur')
}

function getPassValue() {
  if (!props?.randomKey)
    return new Error('randomKey is requied!')

  pgeditor.value.pwdSetSk(props?.randomKey)
  return pgeditor.value.pwdResultSM()
}

// 通过randomKey获取加密后的密码
function handlePgeOnKeyDown() {
  emits('enter', getPassValue())
}

defineExpose({
  clear() {
    pgeditor.value.pwdClear()
  },
  getPassValue,
})
</script>

<template>
  <div :id="props.inputContainerId || '_ocx_password_str'" class="_ocx_password_str" />
</template>

<style>
._ocx_password_str {
  width: 100%;
}

._ocx_password_str>input {
  display: block;
  width: 100%;
  border-radius: 4px;
  line-height: 38px;
  padding-left: 10px;
  padding-right: 10px;
  color: black;
  box-sizing: border-box;
  border: 1px solid var(--el-border-color);
  outline: none;
}

._ocx_password_str>input:focus,
._ocx_password_str>input:focus-visible{
  border-color: var(--el-color-primary);
}
</style>
